import React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    Text,
    TextButton,
    LabeledControl,
    FormField,
    Checkbox,
    Label,
    Spacer,
} from '@zillow/constellation';

// style
import './style.scss';

const propTypes = {
    textContent: PropTypes.node.isRequired,
    submitButtonTitle: PropTypes.string,
    cancelButtonTitle: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    cancelConditions: PropTypes.string,
};

const defaultProps = {
    submitButtonTitle: 'Confirm',
    cancelButtonTitle: 'Cancel',
    cancelConditions: null,
};

const ConfirmationModal = ({
    submitButtonTitle,
    cancelButtonTitle,
    textContent,
    onSubmit,
    onCancel,
    cancelConditions,
}) => {
    const [acceptedCancelConditions, setAcceptedCancelConditions] = React.useState(false);
    return (
        <div className="ConfirmationModal">
            {textContent && (
                <Text>
                    {textContent}
                </Text>
            )}
            {cancelConditions && (
                <Spacer marginY="sm">
                    <Text>
                        {cancelConditions}
                    </Text>
                    <FormField>
                        <LabeledControl
                            controlId="LabeledControl-checkbox-cancel-accept"
                            label={<Label>Yes, I accept the Terms and Conditions</Label>}
                            control={(
                                <Checkbox
                                    name="LabeledControl-checkbox-cancel-accept"
                                    checked={acceptedCancelConditions}
                                    onChange={() => setAcceptedCancelConditions(!acceptedCancelConditions)}
                                />
                            )}
                        />
                    </FormField>
                </Spacer>
            )}
            <div className="ConfirmationModal-controls">
                <TextButton
                    onClick={onCancel}
                    className="ConfirmationModal-cancel"
                    disabled={cancelConditions ? !acceptedCancelConditions : false}
                >
                    {cancelButtonTitle}
                </TextButton>
                <Button
                    onClick={onSubmit}
                    buttonType="primary"
                >
                    {submitButtonTitle}
                </Button>
            </div>
        </div>
    );
};

ConfirmationModal.propTypes = propTypes;
ConfirmationModal.defaultProps = defaultProps;

export { ConfirmationModal };
export default ConfirmationModal;
